<div>
  <Navbar />
    <Sidebar />
    <div class="page-wrapper">
      <div class="hero-section w-100">
        <div class=" d-flex justify-content-between">
          <button class="upload-button text-white d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#upload_modal"
                >
              <i class="fas fa-plus plus-icon me-1"></i> New
          </button>

          <input class="filter-button text-dark d-flex align-items-center"
            v-model="list_search_query"
            type="text"
            placeholder="Filter by name or owner"
            @input="/* reactive via v-model */ null"
          />
        </div>

        <!-- For you (suggested) -->
        <div v-if="for_you_items.length" class="mb-4">
          <h6 class="fw-semibold mb-3">For you</h6>
          <div class="row g-3">
            <div
              v-for="card in for_you_items"
              :key="'card-' + card.id"
              class="col-12 col-md-6 col-xl-4"
            >
              <div class="suggest-card d-flex align-items-stretch">
                <div class="suggest-card-inner w-100 d-flex">
                  <div class="thumb d-flex align-items-center justify-content-center">
                    <i :class="file_icon(card, true)"></i>
                  </div>

                  <div class="flex-grow-1 p-3 min-w-0">
                    <div class="d-flex align-items-center gap-3 overflow-hidden">
                      <div class="min-w-0">
                        <div class="fw-semibold d-block text-truncate">{{ card.name }}</div>
                        <div class="text-muted small text-truncate">
                          Opened {{ format_relative(card.updated_ts) }}
                        </div>
                      </div>

                      <button
                        class="btn btn-outline-secondary btn-sm rounded-pill flex-shrink-0 text-nowrap ms-auto"
                        @click.stop="open_item(card)"
                      >
                        Open
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Breadcrumb Navigation -->
        <div class="breadcrumb-container mt-4">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
              <a href="#"
                @click.prevent="navigate_to_folder(null)"
                class="first-breadcrumb-item"
                @drop.prevent="handle_drop_on_path($event, null)"
              >
                <i class="fas fa-home me-1"></i>
                My Drive
              </a>
            </li>
              <li v-for="(folder, index) in breadcrumb_path" :key="folder.id" class="breadcrumb-item"
                  :class="{ active: index === breadcrumb_path.length - 1 }">

                <a v-if="index < breadcrumb_path.length - 1"
                  href="#"
                  @click.prevent="navigate_to_folder(folder.name)"
                  class="first-breadcrumb-item"
                  :class="{ 'drag-over-path': drag_over_folder_id === folder.id }"
                  @dragover.prevent="drag_over_folder_id = folder.id"
                  @dragleave="drag_over_folder_id = null"
                  @drop.prevent="handle_drop_on_path($event, folder)"
                >
                  {{ folder.name }}
                </a>

                <span v-else class="second-breadcrumb-item">
                  {{ folder.name }}
                </span>
              </li>
            </ol>
          </nav>
        </div>

         <!-- Filter chips (Recent types) -->
        <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
          <span class="text-muted me-1">Recent</span>
          <button
            v-for="opt in chip_options"
            :key="opt.value"
            class="chip"
            :class="{ active: fileTypeFilter === opt.value }"
            @click="fileTypeFilter = opt.value"
          >
            <i :class="opt.icon" class="me-1"></i>{{ opt.label }}
          </button>
        </div>

        <!-- Content Table -->
        <div class="file-list-container">
          <div class="d-none d-md-flex file-list-header pb-2 mb-2 border-bottom text-start">
            <div class="col-6">Name</div>
            <div class="col-2">Opened</div>
            <div class="col-2">Owner</div>
            <div class="col-2 text-end">Activity</div>
          </div>

          <div v-if="filtered_items.length > 0">

            <div
              v-for="file in filtered_items"
              :key="file.id"
              class="file-row d-flex align-items-center py-2 px-3 mb-1 rounded text-start position-relative"
              :class="{ 'drag-over-folder': file.type === 'folder' && drag_over_folder_id === file.id }"
              :draggable="true"
              @click="open_item(file)"
              @dragstart="handle_drag_start($event, file)"
              @dragend="handle_drag_end($event)"
              @dragover="handle_drag_over($event, file)"
              @dragleave="handle_drag_leave($event, file)"
              @drop="handle_drop_on_folder($event, file)"
            >
              <!-- Name -->
              <div class="col-10 col-md-6 d-flex align-items-center gap-2">
                <i :class="file_icon(file)"></i>
                <div class="min-w-0">
                  <div class="fw-semibold text-truncate">
                    {{ file.name }}
                  </div>
                  <div class="text-muted small text-truncate d-none">
                    {{ file.owner }}
                    <span v-if="current_folder === 'My Drive' && file.parent_id !== 'My Drive'">
                      in {{ file.parent_id }}
                    </span>
                    • {{ file.updated_at }}
                  </div>
                </div>
              </div>

              <!-- Opened -->
              <div class="col-2 d-none d-md-block">{{ file.updated_at }}</div>

              <!-- Owner -->
              <div class="col-2 d-none d-md-block">{{ file.owner }}</div>

              <!-- Activity + actions -->
              <div class="col-2 d-none d-md-flex align-items-center justify-content-end gap-2">
                <span class="text-muted small">
                  {{ file.activity}}
                </span>
              </div>

              <!-- Mobile + Desktop Three-Dot Menu -->
              <div v-if="file.type !== 'folder'" class="position-absolute end-0 me-3 dropdown">
                <i
                  class="fas fa-ellipsis-vertical"
                  :id="'dropdown_menu_button-' + file.id"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  @click.stop="toggle_dropdown(file.id)"
                  style="cursor: pointer; font-size: 1.5rem; padding: 0.5rem; color: #6c757d;"
                ></i>
                <ul
                  class="dropdown-menu dropdown-menu-end shadow-sm"
                  :class="{ show: open_dropdown_id === file.id }"
                  :aria-labelledby="'dropdown_menu_button-' + file.id"
                >
                  <li v-if="can_share_file(file)">
                    <a href="#" class="dropdown-item d-flex align-items-center" @click.prevent.stop="share_to_user(file)">
                      <i class="fas fa-share-nodes me-2"></i> Share
                    </a>
                  </li>
                  <li>
                    <a href="#" class="dropdown-item d-flex align-items-center" @click.prevent.stop="preview_file(file)">
                      <i class="fas fa-eye me-2"></i> Preview
                    </a>
                  </li>
                  <li v-if="can_open_in_office(file)">
                    <a
                      href="#"
                      class="dropdown-item d-flex align-items-center"
                      @click.prevent.stop="open_in_office(file)"
                    >
                      <i class="fas fa-file-signature me-2"></i> Open in editor
                    </a>
                  </li>


                </ul>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div v-else class="text-center text-muted my-5">
             No files or folders. Use the "New" button to create or upload.
          </div>
        </div>

      <div class="modal fade" id="upload_modal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header border-bottom-0 pb-0 mb-2">
              <h5 class="modal-title fw-bold" id="uploadModalLabel">Create or Upload</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body pt-0">
              <!-- Tab Buttons: Side-by-side -->
              <div class="btn-group w-100 mb-4" role="tablist">
              <button
                class="btn nav-link small-btn rounded-pill me-2"
                :class="active_tab === 'folder' ? 'upload-button active' : 'filter-button'"
                @click="set_active_tab('folder')"
                data-bs-toggle="pill" data-bs-target="#folder-pane"
                type="button" role="tab" aria-controls="folder-pane"
                :aria-selected="active_tab === 'folder'">
                Create Folder
              </button>
              <button
                class="btn nav-link small-btn rounded-pill me-2"
                :class="active_tab === 'upload' ? 'upload-button active' : 'filter-button'"
                @click="set_active_tab('upload')"
                data-bs-toggle="pill" data-bs-target="#upload-pane"
                type="button" role="tab" aria-controls="upload-pane"
                :aria-selected="active_tab === 'upload'">
                Upload Files
              </button>

              <button
                class="btn nav-link small-btn rounded-pill me-2 d-none"
                :class="active_tab === 'workspace' ? 'upload-button active' : 'filter-button'"
                @click="set_active_tab('workspace')"
                data-bs-toggle="pill" data-bs-target="#workspace-pane"
                type="button" role="tab" aria-controls="workspace-pane"
                :aria-selected="active_tab === 'workspace'">
                AIC Workspace
              </button>
            </div>

              <!-- Tab Content -->
              <div class="tab-content" id="uploadTabContent">
                <!-- Create Folder Tab -->
                <div class="tab-pane fade show active" id="folder-pane" role="tabpanel" aria-labelledby="folder-tab">
                  <div class="mb-3">
                    <input type="text" class="form-control" id="folderName" placeholder="Enter folder name">
                  </div>
                </div>
                <!-- Upload Files Tab -->
                <div  class="tab-pane fade" id="upload-pane" role="tabpanel" aria-labelledby="upload-tab">
                  <label
                    for="drive_file_input"
                    class="upload-box d-flex flex-column align-items-center justify-content-center p-5 border border-2 border-dashed rounded-3 w-100 fa-ellipsis-v"
                    @dragover.prevent="drag_over = true"
                    @dragleave.prevent="drag_over = false"
                    @drop.prevent="handle_drop"
                  >
                    <div class="mb-2">
                      <i class="fa-solid fa-cloud-arrow-up fs-1 text-secondary"></i>
                    </div>
                    <span class="fw-semibold">
                      Click or drag file to this area to upload
                    </span>
                    <input
                      type="file"
                      id="drive_file_input"
                      class="d-none"
                      multiple
                      @change="handle_file_select"
                    />
                  </label>
                  <!-- File Preview List -->
                  <div v-if="uploads.length" class="mt-3 w-100">
                    <div v-for="(file, index) in uploads" :key="index" class="d-flex align-items-center mb-2 px-3 overflow-hidden">
                      <i class="fas fa-file-alt me-2 text-secondary"></i>
                      <span class="text-truncate min-w-0">{{ file.name }}</span>
                    </div>
                  </div>
                </div>
                <!-- AIC Workspace Tab -->
                <div class="tab-pane fade" id="workspace-pane" role="tabpanel" aria-labelledby="workspace-tab">
                </div>
              </div>
            </div>


            <div class="modal-footer border-top-0 pt-0 justify-content-end">
              <button
                type="button"
                class="btn upload-button text-white"
                @click="handle_continue"
                :disabled="uploading_in_progress"
              >
                <span v-if="uploading_in_progress" class="spinner-border spinner-border-sm"></span>
                <span>{{ uploading_in_progress ? 'Submitting...' : 'Submit' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- File Preview Modal -->
<div v-if="preview_modal" @click.self="preview_modal = false">
        <FilePreviewComponent :presigned_url="preview_file_url" @close="close_the_file_preview" :file_name="preview_file_name"
  :shared_access_level="preview_file_access_level" />
</div>

<div v-if="share_modal" class="modal fade show d-block custom-backdrop" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-3">
      <div class="modal-header">
        <h5 class="modal-title gradient-text">Share File</h5>
        <button type="button" class="btn-close" @click="share_modal=false"></button>
      </div>
      <div class="modal-body">
        <p class="fw-bold">Select Access Level:</p>
        <select class="form-control mb-3" v-model="selected_access_level">
          <option disabled value="">Choose Access Level</option>
          <option v-for="level in access_levels" :key="level.id" :value="level.id">
            {{ level.name }}
          </option>
        </select>

        <div v-if="share_link">
          <p class="fw-bold">Generated Link:</p>
          <div class="input-group">
            <input type="text" class="form-control" v-model="share_link" readonly>
            <button class="btn btn-outline-secondary" @click="copy_share_link">
              <i class="fas fa-copy"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button v-if="!share_link" class="btn cta-button text-white" @click="generate_share_link">Generate Link</button>
        <button class="btn btn-secondary d-none" @click="share_modal=false">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- Share with Users Modal -->
<div v-if="share_user_modal" class="modal fade show d-block custom-backdrop" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
    <div class="modal-content modern-modal-content">
      
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title gradient-text">Share File</h5>
        <button type="button" class="btn-close" @click="close_share_user_modal"></button>
      </div>

      <!-- Main Content -->
      <div>
        <div class="modal-body modern-modal-body">

          <!-- Tab-like Buttons -->
          <div class="btn-group w-100 mb-4" role="tablist">
            <button
              class="btn nav-link small-btn rounded-pill me-2"
              :class="share_mode === 'restricted' ? 'upload-button active' : 'filter-button'"
              @click="share_mode = 'restricted'"
              type="button"
            >
              <i class="fas fa-lock me-1"></i> Restricted (Specific Users)
            </button>
            <button
              class="btn nav-link small-btn rounded-pill me-2"
              :class="share_mode === 'link' ? 'upload-button active' : 'filter-button'"
              @click="share_mode = 'link'"
              type="button"
            >
              <i class="fas fa-globe me-1"></i> Anyone with Link
            </button>
          </div>

          <!-- Share via Link -->
          <div v-if="share_mode === 'link'" class="p-4 border-top">
            <label class="fw-bold">Select Access Level:</label>
            <select class="form-select mb-3" v-model="selected_access_level">
              <option disabled value="">Choose Access Level</option>
              <option v-for="level in access_levels" :key="level.id" :value="level.id">
                {{ level.name }}
              </option>
            </select>

            <div v-if="share_link">
              <label class="fw-bold">Generated Link:</label>
              <div class="input-group">
                <input type="text" class="form-control" v-model="share_link" readonly>
                <button class="btn btn-outline-secondary" @click="copy_share_link">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Share with Users -->
          <div v-if="share_mode === 'restricted'" class="p-4 border-top">
             <div class="share-input-group d-flex align-items-center gap-2 mb-4 p-2 border rounded-3 focus-within-ring">
                <div class="position-relative flex-grow-1">
                  <i class="fas fa-user-plus position-absolute top-50 start-0 translate-middle-y text-muted ms-3"></i>
                  <input
                    type="text"
                    class="form-control border-0 ps-5 shadow-none"
                    placeholder="Add names, or email"
                    v-model="user_search_query"
                    @input="filter_users"
                  />
                </div>

                <div class="permission-selector border-start ps-2">
                  <select class="form-select border-0 shadow-none fw-medium text-dark" v-model="user_access_level">
                    <option disabled value="">Select Access level</option>
                    <option v-for="level in access_levels" :key="level.id" :value="level.id">
                      {{ level.name }}
                    </option>
                  </select>
                </div>
              </div>

            <div class="modern-user-list mb-4">
              <div v-if="filtered_available_users.length === 0" class="text-center text-muted py-4">
                <p class="mb-0">No users found</p>
              </div>
              <div
                v-for="user in filtered_available_users"
                :key="user.id"
                class="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 p-3 mb-2 modern-user-card"
                :class="{ 'selected': is_user_selected(user.id) }"
                @click="toggle_user_selection(user)"
              >
                <div class="position-relative flex-shrink-0">
                  <div class="modern-avatar">
                    {{ user.name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) }}
                  </div>
                  <div v-if="is_user_selected(user.id)" class="check-badge">
                    <i class="fas fa-check text-white"></i>
                  </div>
                </div>
                <div class="flex-grow-1 min-w-0">
                  <div class="fw-semibold text-truncate">{{ user.name }}</div>
                  <div class="text-muted small text-truncate">{{ user.email }}</div>
                </div>
                <span class="badge bg-secondary text-light small px-3 py-1 rounded-pill text-nowrap flex-shrink-0">{{ user.role }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Buttons -->
        <div class="modal-footer">
          <button
            v-if="share_mode === 'link' && !share_link"
            class="btn cta-button text-white"
            @click="generate_share_link"
            :disabled="!selected_access_level"
          >
            Generate Link
          </button>

          <button
            v-if="share_mode === 'restricted'"
            class="btn cta-button text-white"
            @click="handle_share_with_users"
            :disabled="selected_share_users.length === 0 || !user_access_level || sharing_in_progress || loading_users"
          >
            <span v-if="sharing_in_progress" class="spinner-border spinner-border-sm"></span>
            <span>{{ sharing_in_progress ? 'Sharing...' : 'Share' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<PoweredBy />